export default __webpack_public_path__ + "static/image02-c2c9e4bf110c248423c318f4d914dec4.webp";